<template>
  <BaseSection id="info-alt" space="56">
    <v-container>
      <v-row justify="space-between">
        <v-col cols="12" md="5">
          <BaseBusinessInfo></BaseBusinessInfo>
        </v-col>

        <v-col cols="12" md="6">
          <BaseContactForm></BaseContactForm>
        </v-col>
      </v-row>
    </v-container>
  </BaseSection>
</template>
